<template>
  <div>
    <News v-if="isMobile" :allnewsList="allnewsList" :tabs="tabs" :currentTab="currentTab"/>
    <NewsPC v-else :allnewsList="allnewsList" :tabs="tabs" :currentTab="currentTab" />
  </div>
</template>
<script>
import { Mixins } from '@ireader/core-lib';
import NewsPC from './components/newsPC.vue';
import News from './components/news.vue';
import { isMobile } from '@/utils/utils';
export default {
  name: 'allnews',
  mixins: [Mixins.sdd()],
  data: function () {
    return {
      allnewsList: [],
      currentTab: '',
      tabs: [],
      isMobile: isMobile()
    };
  },
  components: {
    NewsPC,
    News
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
    async getNewsList() {
      try {
        const res = await this.$getSdd('zycom/news_list');
        if (Array.isArray(res) && res.length > 0) {
          this.allnewsList = res;
          this.tabs = res.map(item => ({
            title: item.date,
            value: item.date
          }));
          this.currentTab = this.tabs[0].value;
        }
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
<style lang="scss">

body {
  background: #fff;
}
</style>
